// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3gv1J","boxTitle":"Qualiphy_boxTitle__2RMhv","box":"Qualiphy_box__34e2y","toggleWrap":"Qualiphy_toggleWrap__3jtl7"};